class TabSyncCoordinator {
  constructor() {
    this.tabRefs = new Map();
    this.activeTabIndex = 0;
    this.transitioning = false;
    this.stateSnapshot = null;
    this.ignoreUpdates = false;
    this.lastSyncTime = 0;
    this.lastSyncVideoUrl = null;
  }
  
  registerTab(index, ref) {
    this.tabRefs.set(index, ref);
    return () => this.tabRefs.delete(index);
  }
  
  setActiveTab(index) {
    this.activeTabIndex = index;
  }
  
  startTabTransition(tabIndex, stateSnapshot) {
    this.transitioning = true;
    
    // 确保复制完整的快照并包含所有必要的字段
    const enhancedSnapshot = {
      ...stateSnapshot,
      // 如果没有 robotId 但有 videoUrl，尝试提取
      robotId: stateSnapshot.robotId || (() => {
        if (stateSnapshot.videoUrl) {
          const match = stateSnapshot.videoUrl.match(/video(\d+)/);
          return match ? parseInt(match[1]) : null;
        }
        return null;
      })()
    };
    
    // 保存状态快照
    this.stateSnapshot = JSON.parse(JSON.stringify(enhancedSnapshot));
    console.log('TabSyncCoordinator: 保存的状态快照:', this.stateSnapshot);
    
    this.setActiveTab(tabIndex);
  }
  
  completeTabTransition() {
    this.transitioning = false;
    this.stateSnapshot = null;
  }
  
  getActiveTabRef() {
    return this.tabRefs.get(this.activeTabIndex) || null;
  }
  
  shouldRespondToUpdate(tabIndex, source) {
    if (this.ignoreUpdates) return false;
    
    if (this.transitioning && tabIndex !== this.activeTabIndex) {
      return false;
    }
    
    if (source && source.includes(`tab_${tabIndex}`)) {
      return false;
    }
    
    return true;
  }

  ignoreAllUpdates() {
    this.ignoreUpdates = true;
  }
  
  resumeUpdates() {
    this.ignoreUpdates = false;
  }

  // 增强的视频同步方法
  syncVideoState(videoUrl, currentTime, sourceTab) {
    if (this.ignoreUpdates) return;
    
    // 避免重复同步
    if (this.lastSyncVideoUrl === videoUrl && 
        Math.abs(this.lastSyncTime - currentTime) < 0.1) {
      return;
    }
    
    this.lastSyncVideoUrl = videoUrl;
    this.lastSyncTime = currentTime;
    
    // 尝试从 URL 中提取 robotId
    let robotId = null;
    const robotIdMatch = videoUrl.match(/video(\d+)/);
    if (robotIdMatch) {
      robotId = parseInt(robotIdMatch[1]);
    }
    
    console.log(`TabSyncCoordinator: 同步视频状态 - URL=${videoUrl}, robotId=${robotId}, time=${currentTime}`);
    
    // 通知所有非源tab进行更新
    this.tabRefs.forEach((ref, index) => {
      if (index !== sourceTab && ref && ref.current) {
        if (ref.current.handleVideoSelect) {
          // 确保传递 robotId 作为参数
          console.log(`TabSyncCoordinator: 同步到tab ${index}`);
          ref.current.handleVideoSelect(videoUrl, currentTime, true, robotId);
        }
      }
    });
  }
  
  // 验证状态快照中是否包含必要信息
  verifyStateSnapshot() {
    if (!this.stateSnapshot) return false;
    
    // 检查关键信息是否存在
    if (!this.stateSnapshot.videoUrl) {
      console.warn('TabSyncCoordinator: 状态快照中缺少视频URL');
      return false;
    }
    
    // 验证 robotId (从 videoUrl 提取)
    if (!this.stateSnapshot.robotId) {
      const robotIdMatch = this.stateSnapshot.videoUrl.match(/video(\d+)/);
      if (robotIdMatch) {
        this.stateSnapshot.robotId = parseInt(robotIdMatch[1]);
        console.log(`TabSyncCoordinator: 从URL中提取并设置robotId=${this.stateSnapshot.robotId}`);
      }
    }
    
    return true;
  }
}

const tabSyncCoordinator = new TabSyncCoordinator();
export default tabSyncCoordinator;